import { render, staticRenderFns } from "./simDeleteRecord.vue?vue&type=template&id=f0b9ede4&scoped=true&"
import script from "./simDeleteRecord.vue?vue&type=script&lang=js&"
export * from "./simDeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b9ede4",
  null
  
)

export default component.exports